<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{Title}}</p>
      <button class="delete" aria-label="close" (click)="cancel()"></button>
    </header>

    <section class="modal-card-body library-import-body">
      @if (Subtitle) {
        <p class="has-text-grey mb-3">{{Subtitle}}</p>
      }

      <div class="field has-addons mb-3">
        <div class="control is-expanded has-icons-left">
          <input class="input is-fullwidth" type="text" placeholder="Search..." [(ngModel)]="Search" [disabled]="Loading" />
          <span class="icon is-small is-left">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <div class="control">
          <button class="button is-light" [disabled]="Loading" (click)="Refresh()" title="Refresh">
            <span class="icon"><i class="fas fa-sync"></i></span>
          </button>
        </div>
      </div>

      @if (Loading) {
        <div class="library-import-loading">
          <i class="fas fa-spinner fa-spin fa-2x library-import-loading-spinner" aria-hidden="true"></i>
          <div class="sr-only">Loading library items...</div>
        </div>
      }

      @if (!Loading) {
        <div class="table-container library-import-items">
          <table class="table is-fullwidth is-hoverable is-striped is-narrow">
            <thead>
              <tr>
                <th style="width: 3rem;"></th>
                <th>Item</th>
                <th style="width: 14rem;">Source</th>
              </tr>
            </thead>
            <tbody>
              @for (item of FilteredItems; track item) {
                <tr (click)="toggleSelected(item)" style="cursor:pointer;">
                  <td>
                    <input type="checkbox" [checked]="isSelected(item)" (click)="$event.stopPropagation(); toggleSelected(item)" />
                  </td>
                  <td>
                    <div style="font-weight: 600;">{{ item.name }}</div>
                    <div class="has-text-grey is-size-7">{{ item.description }}</div>
                  </td>
                  <td>
                    <span class="tag is-light">{{ item.sourceOrganizationName }}</span>
                  </td>
                </tr>
              }
              @if (FilteredItems.length === 0) {
                <tr>
                  <td colspan="3" class="has-text-grey">No items match your search.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>

    <footer class="modal-card-foot">
      <button class="button is-primary" [disabled]="Loading || SelectedCompositeKeys.size === 0" (click)="confirm()">
        Confirm ({{SelectedCompositeKeys.size}})
      </button>
      <button class="button" (click)="cancel()">Cancel</button>
    </footer>
  </div>
</div>


